/**
 * Created by Languagenut on 19/06/2019.
 */

import React  from 'react';
import {Col , Row  , Modal , Button} from 'react-bootstrap'
import FieldGroup from '../FieldGroup.js';
import assignmentServices from '../../services/assignments-service.js';
import Recorder from '../../components/feedbackRecorderUploader.js'
import Config from '../../classes/config.js';
import CatalogService from '../../services/content-service.js';
import Translation from '../../store/internationalization-store.js';
import jsPDF from 'jspdf';

export default class StudentGradeContent extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {saveButtonPressed:false};
    }

    componentWillReceiveProps(props) {
        if (this.refs.sourcedAudio != undefined) {
            this.refs.sourcedAudio.load();
        }
        this.supportDataUrl = undefined;
        this.props = props;
        if (this.props.data == undefined || this.props.uid == undefined) {
            return;
        }
        var currentRow = this.props.data[this.props.uid];
        if (currentRow == undefined || this.props.i || currentRow.rawData == undefined) {
            return;
        }
        currentRow.rawData.commentNew = currentRow.rawData.comment;
        currentRow.rawData.gradeNew = currentRow.rawData.percentage;
        if (currentRow.rawData.gradeNew == null) {
            currentRow.rawData.gradeNew = "";
        }

        var toIetf = 'en'
       //var toIetf = curriculumStore.languageUid;
        if (currentRow.rawData.game_uid == "216" || currentRow.rawData.game_uid == "215" || currentRow.rawData.game_uid == "214") {
            toIetf = "EXTRA";
        }

        if(this.props.show){
            CatalogService.getExamDataQuestion(currentRow.rawData.game_uid,
                currentRow.rawData.rel_module_uid, toIetf, "en").then(function(response){
                    this.setState({props:this.props,loading:true,
                        uid:this.props.uid,
                        examQuestion:response,
                        grade:currentRow.rawData.gradeNew,
                        writtenFeedback:currentRow.rawData.comment,
                        audio: currentRow.rawData.audio,
                        hasChanged:false,
                        saveButtonPressed:false
                    })
                }.bind(this));
        }
        
    }

    saveFeedback() {
        if ( this.state.saveButtonPressed == true) {
            return;
        }
        this.state.saveButtonPressed = true;
        var supportData = this.supportDataUrl;
        var currentRow = this.state.props.data[this.state.uid];
        var keys = [];
        var grade = undefined;
        var writtenFeedback = "";
        if (currentRow.rawData.is_homework == true) {
            keys = [currentRow.rawData.key1, currentRow.rawData.key2, currentRow.rawData.key3,
                currentRow.rawData.key4, currentRow.rawData.key5, currentRow.rawData.key6
                ,currentRow.rawData.key7]
        } else {
            keys = [currentRow.rawData.key1]
        }
        if (this.state.grade != "") {
            grade = this.state.grade;
        }
        if (this.state.writtenFeedback != "") {
            writtenFeedback = this.state.writtenFeedback;
        }
        var cannotGrade = false;
        if (currentRow.rawData.cannotGrade != undefined) {
            cannotGrade = true;
        }

        assignmentServices.gradeQuestion(grade, keys, currentRow.rawData.is_homework, 
            writtenFeedback, supportData, cannotGrade).then(function(){
                if(this.props.onSave) this.props.onSave();
                

        }.bind(this))
        
    }

    onHide() {
        this.setState({examQuestion:undefined});
        this.props.onHide();
    }

    downloadText(name, value,questionName,due,text)
    {
        var pdf   = new jsPDF();
        pdf.setFontSize(16);
        pdf.setTextColor(33, 20, 60);
        var studentName = String(name);
        //var module = this.state.allHeaders[jdx];
        pdf.text(10, 20, Translation.get(14 , 'Name') +": "+ studentName);
        pdf.text(10, 28, Translation.get(12211 , 'Grade') +": "+ value || '0%');
        pdf.text(10, 36, Translation.get(12151 , 'Question') +": "+ String(questionName));
        pdf.text(10, 44, Translation.get(484 , 'Due') +": "+ due);


        var splitTitle = pdf.splitTextToSize(String(text).replace(/(?:\r\n|\r|\n)/g, '\n\n'), 180);

        for(var idx =0; idx < splitTitle.length; idx++)
        {
            var text = splitTitle[idx];
            pdf.text(10, 55 + idx*10, text);
        }
                   //   pdf.text(10, 60, splitTitle);
        pdf.save(String(name)+' '+due+'.pdf');
    }

    render() {
        if (this.state.props == undefined) {
            return "";
        }
        if (this.state.examQuestion == undefined) {
            return "";
        }
        var header = "";
        var name = "";
        var imageData = "";
        var audioData = "";
        var userDataFinal = "";
        var examText = "";
        var examDataText = "";
        var currentRow = this.state.props.data[this.state.uid];

        if (currentRow == undefined || currentRow.rawData == undefined) {
            return "";
        }
        if (this.refs.sourcedAudio != undefined) {
            this.refs.sourcedAudio.load();
        }
        if (currentRow.rawData.cannotGrade == undefined) {
            if (currentRow.rawData.file != "" && currentRow.rawData.file != undefined && 
                currentRow.rawData.file != null) {
                    userDataFinal = <div><b >{Translation.get(12659 , "Student's Answer")}:</b>
                        <br/>
                        <audio ref="sourcedAudio" style={{width:'100%' , marginTop:'10px'}} controls>
                            <source src={Config.getFeedbackBaseUrl()+currentRow.rawData.file} />
                            Your browser does not support the video tag.</audio></div>
            } else {
                var textRaw = ""

                try /// MISSING DATA IN THE DATABASE I THINK THIS IS A CATCH SO PAUL CAN REVIEW
                {
                    textRaw = currentRow.rawData.text.replace(this.state.examQuestion.examData.text, "");
                }
                catch(e)
                {
                    textRaw = ''
                }
                var name = currentRow.rawData.nickname;
                var value = currentRow.rawData.gradeNew;
                var questionName = this.state.examQuestion.examData.text;
                var due = currentRow.rawData.last_updated;
                userDataFinal =<div><b>{Translation.get(12659 , "Student's Answer")}:</b><Button onClick={
                    this.downloadText.bind(this ,name, value,questionName,due,textRaw)
                    
                    } className="float-right">{Translation.get(826 , "Download")}</Button><br/><br/><br/><div class="scroll" style={{maxHeight:"200px"}}>
                    {textRaw}
                </div></div>
            }
        
            name = currentRow.name;
            if ((currentRow.rawData.game_uid == "208" || currentRow.rawData.game_uid == "214" || 
                currentRow.rawData.game_uid == "217") &&
                this.state.examQuestion.examData.image != "" && this.state.examQuestion.examData.image != undefined
                && this.state.examQuestion.examData.image != null) {
                imageData = <center><img src={Config.getBaseUrl()+"vocabs/"+
                        this.state.examQuestion.examData.image} alt="logo"  style={{maxWidth:"60%"}}/></center>
            }

            if (currentRow.rawData.game_uid == "215") {
                examText = <div>{this.state.examQuestion.examData.text_extra}</div>
            }

            if ((currentRow.rawData.game_uid == "216") &&
                this.state.examQuestion.examData.writing_audio != "" && this.state.examQuestion.examData.writing_audio != undefined
                && this.state.examQuestion.examData.writing_audio != "null") {
                    if (this.state.examQuestion.examData.writing_audio.indexOf(".mp4") > -1) {
                        audioData = <center><video width="320" height="200" controls>
                        <source src={Config.getBaseUrl()+this.state.examQuestion.examData.writing_audio} type="video/mp4"/>
                        Your browser does not support the video tag.
                        </video></center>
                    } else {
                        audioData = <audio controls>
                        <source src={Config.getBaseUrl()+this.state.examQuestion.examData.writing_audio} type="video/mp4"/>
                        Your browser does not support the video tag.
                        </audio>
                    }
            }
            examDataText = <h6><b>{this.state.examQuestion.examData.text}</b></h6>
            var enterGrade = <Row  className="strong">
                    <Col md={12}>
                        <FieldGroup id="grade" label={Translation.get(12660 , 'Grade by percentage %')}
                                value={this.state.props.data[this.props.uid].rawData.gradeNew} onChange={function(event){
                                    if (isNaN(event.target.value) || event.target.value > 100){
                                        this.state.props.data[this.props.uid].rawData.gradeNew = this.state.props.data[this.props.uid].rawData.gradeNew; 
                                        this.setState({hasChanged:true , grade:this.state.props.data[this.props.uid].rawData.gradeNew});
                                        return;
                                    } 
                                    this.state.props.data[this.props.uid].rawData.gradeNew = event.target.value; 
                                    this.setState({hasChanged:true , grade:event.target.value})}.bind(this)}
                                />
                    </Col>
                </Row>
            header = <div>{examDataText}
                    {examText}
                    {imageData}
                    {audioData}
                    <br></br>
                    <br></br>
                    {userDataFinal}
                    <hr/>
                    {enterGrade}
                    <hr/></div>
        }


        return (
            <Modal
                {...this.props}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        {name}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {header}
                    <Row className="strong">
                        <Col md={8}>
                            <div >
                                <FieldGroup className="strong" as="textarea" label={Translation.get(12661 , 'Teacher comment (visible to your students)')}  type="textarea" placeholder="" value={this.state.props.data[this.props.uid].rawData.commentNew}
                                    onChange={(event)=>{ this.state.props.data[this.props.uid].rawData.commentNew = event.target.value; this.setState({hasChanged:true , writtenFeedback:event.target.value})}}/>
                            </div>
                        </Col>
                        <Col md={4}>
                            <Recorder recorded={this.state.recorded} baseFile={this.state.audio} audioPreview={this.path} onChange={(dataURL)=>{ this.setState({hasChanged:true , recorded:true});  this.supportDataUrl = dataURL}} />
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                     <Button onClick={this.onHide.bind(this)}>{Translation.get(41 , 'Cancel')}</Button> <Button disabled={!this.state.hasChanged} onClick={this.saveFeedback.bind(this)}>{Translation.get(657 , 'Save')}</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}